"use strict";exports.getSpecialCharactersRegex=e=>e?new RegExp(".*[^\\w\\s]{".concat(e,",}")):void 0;
